import { Button } from 'react-admin';
import { Tooltip, Box } from '@mui/material';
import EditIcon from '@/assets/icons/edit-icon.svg?react';

const CustomEditIconButton = ({ onOpen, title, tooltipTitle, sx }) => {
    const btn = (
        <Button onClick={onOpen} title={tooltipTitle ? undefined : title} variant='contained' className='button--icon-only button--edit' sx={sx}>
            <>
                <EditIcon />
            </>
        </Button>
    );

    if (!tooltipTitle) {
        return btn;
    }

    return (
        <Tooltip title={tooltipTitle} arrow placement='bottom' classes={{ tooltip: 'tooltip-campaign' }}>
            <Box>{btn}</Box>
        </Tooltip>
    );
};

export default CustomEditIconButton;
